import Component from 'gia/Component';

export default class BackToTop extends Component {
  constructor(element) {
    super(element);

  }

  mount() {
   this.element.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }


}